function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 59,
  height: 59,
  rx: 5.5,
  fill: "white",
  stroke: "#EDEEF0"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.7234 19.3326H43.089C43.6908 19.3326 44.1786 19.8205 44.1786 20.4222V41.7692C44.1786 42.371 43.6908 42.8588 43.089 42.8588H17.3747C16.773 42.8588 16.2852 42.371 16.2852 41.7692V20.4222C16.2852 19.8205 16.773 19.3326 17.3747 19.3326H22.7404V18.2341C22.7404 17.6323 23.2282 17.1445 23.83 17.1445C24.4317 17.1445 24.9195 17.6323 24.9195 18.2341V19.3326H35.5442V18.2341C35.5442 17.6323 36.032 17.1445 36.6338 17.1445C37.2356 17.1445 37.7234 17.6323 37.7234 18.2341V19.3326ZM18.4648 40.6796H42V21.5117H37.7239V22.6102C37.7239 23.212 37.2361 23.6998 36.6343 23.6998C36.0325 23.6998 35.5447 23.212 35.5447 22.6102V21.5117H24.9201V22.6102C24.9201 23.212 24.4322 23.6998 23.8305 23.6998C23.2287 23.6998 22.7409 23.212 22.7409 22.6102V21.5117H18.4648V40.6796Z",
  fill: "black"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.2327,
  cy: 28.8538,
  r: 1.47094,
  fill: "black"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.2327,
  cy: 35.2561,
  r: 1.47094,
  fill: "black"
});
var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.8303,
  cy: 28.8538,
  r: 1.47094,
  fill: "black"
});
var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.635,
  cy: 28.8538,
  r: 1.47094,
  fill: "black"
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 23.8303,
  cy: 35.2561,
  r: 1.47094,
  fill: "black"
});
var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 36.635,
  cy: 35.2561,
  r: 1.47094,
  fill: "black"
});
function SvgIconOpenEnrollment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpenEnrollment);
export default __webpack_public_path__ + "static/media/icon-open-enrollment.8e2325cf.svg";
export { ForwardRef as ReactComponent };